// Базовые проверки полей компании при сохранении. Те же правила проверяет сервер
// (services/main, helpers/companyFields.js): он форме не доверяет.

// Колонки varchar(255), самое длинное значение в базе сейчас 47 знаков. Эти пределы не дают
// вставить в название страницу текста и не задевают настоящие названия.
export const LIMITS = { name: 150, director: 100, state: 100, region: 100, city: 100 };
const LABEL = {
  name: "Название",
  director: "Имя директора",
  state: "Область",
  region: "Район",
  city: "Населённый пункт",
};

// generalArea это decimal(14,2): до двенадцати цифр перед запятой.
const AREA_MAX = 999999999999;

// Что не так с площадью (пустая строка, если всё в порядке). Пусто можно (у колонки есть значение
// по умолчанию), ноль это настоящее значение (в базе есть компании с 0.00).
export const areaError = (value) => {
  if (value === undefined || value === null) return "";
  if (typeof value === "string" && !value.trim()) return "";
  const number = typeof value === "number" ? value : Number(String(value).trim());
  if (!Number.isFinite(number)) return "Площадь: нужно число";
  if (number < 0) return "Площадь не может быть отрицательной";
  if (number > AREA_MAX) return "Площадь слишком большая";
  return "";
};

// Слишком длинный текст: что сказать человеку (пустая строка, если длина в пределах).
export const tooLongError = (field, value) =>
  typeof value === "string" && value.trim().length > LIMITS[field]
    ? `${LABEL[field]}: не длиннее ${LIMITS[field]} знаков`
    : "";
